<script setup lang="ts"></script>

<template>
  <icon name="lucide:chevrons-up-down" />
</template>

<style scoped></style>
